import { createSlice } from "@reduxjs/toolkit";
import {
  GET_USER_TYPE_SUCCESS,
  GET_USER_TYPE_FAIL,
  SET_IMPERSONATED_EMAIL,
  CLEAR_IMPERSONATED_EMAIL,
  SET_ORIGINAL_USER_EMAIL,
  CLEAR_ORIGINAL_USER_EMAIL,
  SET_SESSIONALERT_SUCCESS,
  SET_SESSIONALERT_FAIL,
  SET_CHECK_IN_FLAG_SUCCESS,
  SET_CHECK_IN_FLAG_FAIL,
  SET_MASTER_FETCH_TIMESTAMP,
  SET_SELECTED_SALESGROUPCODE_SUCCESS,
  SET_SELECTED_SALESGROUPCODE_FAIL,
} from "../constants/action-types";

// --- User Type Slice ---
const userTypeSlice = createSlice({
  name: "userType",
  initialState: { type: "" },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(GET_USER_TYPE_SUCCESS, (state, { payload }) => {
        state.type = payload;
      })
      .addCase(GET_USER_TYPE_FAIL, (state) => {
        state.type = "";
      });
  },
});

// --- Impersonation Slice ---
const impersonationSlice = createSlice({
  name: "impersonation",
  initialState: { impersonatedEmail: "", originalUserEmail: "" },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(SET_IMPERSONATED_EMAIL, (state, { payload }) => {
        state.impersonatedEmail = payload;
      })
      .addCase(CLEAR_IMPERSONATED_EMAIL, (state) => {
        state.impersonatedEmail = "";
      })
      .addCase(SET_ORIGINAL_USER_EMAIL, (state, { payload }) => {
        state.originalUserEmail = payload;
      })
      .addCase(CLEAR_ORIGINAL_USER_EMAIL, (state) => {
        state.originalUserEmail = "";
      });
  },
});

// --- Session Alert Slice ---
const sessionAlertSlice = createSlice({
  name: "sessionAlert",
  initialState: { Alert: "" },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(SET_SESSIONALERT_SUCCESS, (state, { payload }) => {
        state.Alert = payload;
      })
      .addCase(SET_SESSIONALERT_FAIL, (state) => {
        state.Alert = "";
      });
  },
});

// --- Check-In Flag Slice ---
const checkInFlagSlice = createSlice({
  name: "checkInFlag",
  initialState: { wssCountFlag: "" },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(SET_CHECK_IN_FLAG_SUCCESS, (state, { payload }) => {
        state.wssCountFlag = payload;
      })
      .addCase(SET_CHECK_IN_FLAG_FAIL, (state) => {
        state.wssCountFlag = "";
      });
  },
});

// --- Master Fetch Status Slice ---
const masterFetchSlice = createSlice({
  name: "masterFetchStatus",
  initialState: { lastFetchedAt: null },
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(SET_MASTER_FETCH_TIMESTAMP, (state, { payload }) => {
      state.lastFetchedAt = payload;
    });
  },
});

// --- Selected Sales Group Code Slice ---
const selectedSalesGroupSlice = createSlice({
  name: "SelectedSalesGroupCode",
  initialState: { SelectedSalesGroupCode: "" },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(SET_SELECTED_SALESGROUPCODE_SUCCESS, (state, { payload }) => {
        state.SalesGroupCode = payload;
      })
      .addCase(SET_SELECTED_SALESGROUPCODE_FAIL, (state) => {
        state.SalesGroupCode = "";
      });
  },
});

export const getUserTypeReducer = userTypeSlice.reducer;
export const impersonationReducer = impersonationSlice.reducer;
export const setSessionAlertReducer = sessionAlertSlice.reducer;
export const setCheckInFlagReducer = checkInFlagSlice.reducer;
export const masterFetchStatusReducer = masterFetchSlice.reducer;
export const setSelectedSalesGroupCode = selectedSalesGroupSlice.reducer;
